import React from 'react'

import { connect } from 'react-redux';
import * as actionCreators from '../../actions/user'
import PropTypes from "prop-types";
import { bindActionCreators } from 'redux';

import Typography from '@material-ui/core/Typography';
import Divider from '@material-ui/core/Divider';
import Switch from '@material-ui/core/Switch';
import SearchIcon from '@material-ui/icons/Search'
import AssignmentIndIcon from '@material-ui/icons/AssignmentInd';
import CreateIcon from '@material-ui/icons/Create'
import IconButton from '@material-ui/core/IconButton';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import { UserApi } from '../../api/usersApi'
import { InstagramApi } from '../../api/instagram_api'
import { PurchaseApi } from '../../api/purchaseApi'
import Notification from '../Notifications'
import { ADMIN_ROLE } from '../../constants'
import Suggestor from '../../utils/suggest'
import Checkbox from '@material-ui/core/Checkbox';
import NumberFormat from 'react-number-format';
import MUIDataTable from "mui-datatables";
import Modal from '@material-ui/core/Modal';
import Paper from '@material-ui/core/Paper';
import { PoItems } from './po_items'
import { CustomerMetrics } from './Metrics'
import { ContactModal, AccountModal } from './EditCustomer'
import Moment from 'react-moment'
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';

import { validateEmail } from '../../utils/misc'


import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import CircularProgress from '@material-ui/core/CircularProgress';
import FormControl from '@material-ui/core/FormControl';


function mapStateToProps(state) {
    return {
        userRoles: state.user.userRoles

    };
}

function mapDispatchToProps(dispatch) {
    return {}
}

const SudacaDays = {
    'SU': 'Domingo',
    'MO': 'Lunes',
    'TU': 'Martes',
    'WE': 'Miercoles',
    'TH': 'Jueves',
    'FR': 'Viernes',
    'SA': 'Sabado',
}

const customStyles = {
    top: `10%`,
    margin: 'auto',
    width: 800,
    height: 500,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const styleContact = {
    top: `30%`,
    margin: 'auto',
    width: 300,
    height: 400,
    content: {
        top: '50%',
        left: '50%',
        right: 'auto',
        bottom: 'auto',
        marginRight: '-50%',
        transform: 'translate(-50%, -50%)'
    }
};

const NO_IMAGE = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAMgAAADICAMAAACahl6sAAAAM1BMVEUKME7///+El6bw8vQZPVlHZHpmfpHCy9Ojsbzg5ekpSmTR2N44V29XcYayvsd2i5yTpLFbvRYnAAAJcklEQVR4nO2d17arOgxFs+kkofz/154Qmg0uKsuQccddT/vhnOCJLclFMo+//4gedzcApf9B4srrusk+GsqPpj+ypq7zVE9LAdLWWVU+Hx69y2FMwAMGyfusLHwIpooyw9IAQfK+8naDp3OGHvZ0FMhrfPMgVnVjC2kABOQ1MLvi0DEIFj1ILu0LU2WjNRgtSF3pKb4qqtd9IHmjGlJHlc09IHlGcrQcPeUjTAySAGNSkQlRhCCJMGaUC0HSYUx6SmxFAtJDTdylsr4ApC1TY0yquKbCBkk7qnYVzPHFBHkBojhVJWviwgPJrsP4qBgTgbQXdsesjm4pDJDmIuswVZDdFx0ENTtkihoeqSDXD6tVxOFFBHndMKxWvUnzexpIcx/Gg2goJJDhVo6PCMGRAnKTmZuKm3wcJO/upphUqUHy29yVrRhJDORXOKIkEZDf4YiRhEF+iSNCEgb5KY4wSRDkB/yurUEG8nMcocgYABnvbrVL3nMIP0h/d5udKnwzSC/InfPdkJ6eWb0PJE++dyVVyQP5iQmWW27X5QG5druEKafBu0Hqu9saVOHa8HKC/K6BzHKZiRMEZCDF0Nd1/ZfXI/fcOibHOssFgokg9uFA20BhztHEAZIjIohrD/o1wljeFBDEwBo8YUt5Ir/rNLjOIACPFdy/AbEcPdcJBOCxytjeYAM4Kzp6rhOIPhRGNzwmFP3rOoTFI0irtnQKx6fj1Zt+h9njEUS9mKJxfFRrX5lt7wcQtaWTOfTHeIXVJQcQrRW+OYex2j0a66XZINoO8a7fPH2iHF2mC7ZBtB3Czb5QvjizSx7A3308mRzqAwujSywQbYfwc0iU8zqjS0yQ6ztEHX9332KCaGNIYB/Qq1z3yN0oDZBWyeFYJBCkm2sXLhDtpKFwNDMu5TnrZpYGiHbK4Nlwikg5DrYV1g6iPoJmzE5MKd/fOp53EPUaQZaLqH3u+vo2ELWp3wSyWuYGoj9EEIJoV3L9AUS/ZLsJpLNBXmqOu0CW6P5A/dx9IL0FAji/FYKot9EqE0Tvs6QBUe/2CxMEkZAlBNGPhdoAQWyTSmbxUwvUygwQyMmniAPgLt87CODXHuftWJIQgzrfQDC5AfwSgz9MmmG/gWCOqDgZ4JsQeTvZBoJJDhAFEsSDyxUEEUUekk0UEMhjBcEcGsoWVpBU3NcCgkkPkJWrKbdRZvULCMTWhYEdMrayBQRyqHcnSLmAIH7LcWJ8Hch7BsHEdWFpJsZjziCgFBpZ9TPm4e0XBJTTJKt9xjy8RoLI4gimPLP5goCSgWTrEcyzsy8IqmZVMo0H5bJiQToBCOjZ5RcElhjLN3dU7uQMAvoxwQkJZKI1CQzCthJYEigahHuDDi4rFwzCPQ7F1fiDQZgTR5iJwEGYRgIsiECD8BwwMAEfDcIaW8CRBQdhjS1kJQEchDEFhiRKr4KDFPS9FGQNVwEHoW83QjsEHdkfnuIOl6C1NjMItiaCaCWgbdpFJXQ9soh2uoB9aJcCxFdgZwlcrTmvENGlrITBBdpK25Qhd1F2RScq8CKu/gsCL8qN5THjy+Rr5E6joYgPxpdl518QrCf8Kpgjn6C8HLkbb+vt7ZM8wdVvy258khsRfHaS5DalDnlidZT7Erk+SXV5Bj1D3LS29XyhVJuoKHs9Q8S6reK11oUc7vPcr9uswP3SLiDINefXOF5rwCuGzVT6zVkVPfh2wWmHcz4wAwba2cgN1/Tsvleu7//i69CgVyt1GwjOs2+XK3rtbl151Tg3vOeioG40Mz2V+6pQ4xbJHOZj6g0EMxk93tV7fuedvVZpQSPhbwNBGInrymGrwNh1GXmL8F+lAaJ+NU/fzcmvJqvKj7177+1v1GY/GiBKI1Fdy/2XK6upXwaIJpI8B/399W0mH9zzafKaeCF9J0WF+jyCuFusTGzZKhFH8dVLZql2brxgcdVBKb7KG/7UZTmB3XJ6uL/QYT5ScRI74FcHEJ7feopyfGkaeaGlPoCw/BbjZmSBWIvINQNmTxdjWJqwUI8sztR4nYPuIPSTSUnOCZOE3ierqRoJfNSQxDjLEYs8i91eqgFCDSWiFHiuqAN9CwEGCPEISVjvwhS7Mfx6dtX8kC5aqvneGBOEFN2v6RBiYwr3DQOkLhEW6fHFbIwFQnkLiWYmZxE220z/aedPx99C+hiyKR4OzNFhg8S75CJTnxQ1dyugHTLaY10iu9dBpmhQtMz1ABLrkgtHVnRsPUO3OcU25i8cWdGxZbflCBKJqBdMs3aF/dYhNexU9RFcYEmLXYQKghyWdufyldBSU3KpjkKhZclxTXQGCTkL/HZDUIH5+Gkt4SgoCtj7pSYSNJLTK3VVRnmXZxebSMBIzmHABeIdXBebiN9eHYtUZ62ab3BdGkUm+SKJw1bdRXeewaX7qqdAnljg2sVxg3guAk3baofcg9yZ2eZpnHNvSFrEqhB9YPjesmt0pt6Xc8hl7W5L9Q4Xx09ctsrd5VhWeF6nF8SRrZdw49qns//0xTK/AZ8vGr3caTliuzeFNeCJTgafpKlhHd2WP1sy1LqDF798gjKJPLqDr9keoTd43+NyNzC1CI8Xy2lcPtOaVBI5IiAWyQ3e125AcKoXs2Djhy5eVc3KiBxREIPkhjBiLhIjU++4T91IbggjRiCJLSEIwWGddkEaxlVN5KCArPHk8mXVpHk8FHH7JL3n5dPA7C90q7XkeFJucacNmGXeRfswLE71HA79efaGiCN/Ofjmfmtcp8X10tIsqCacV5xfRWjNUiXGYbovWgyFYHcQLak15K9oM5zqmgaeKsHJetbSHfSPzXOiw/rxE9YH4CXaUpsZ0ztemFurP95Jpyvrd29YTpIZr7cEJHqfc7Wl0PFm2+yJR70udaokKFtGPTdm8WdQe24+HmVLlueboWQquBcYYVH2vEzfh8kCks1p90eWsLCyZ8qK7E86Oe+3XYFnBuiWdth20UqZR5SvMoyPg3WNauJipi0LMTQgVq5xUUlZcrPsopPHJ926z8pm7xyFLrH/PxpHSoXKdWgXsLn1scZn1ZDd/2vszN3lt254qkE+qu3yoqLM+ghN3Qz2qcVzUC/ZMFsK/alU6l0OWV/bQz6v6yYbyuN5BaZ4A7Y30vs/PPksS2+qzlvfF7OQmzzcL7W+xa7OIfRuVdtn/tdvdFLnL4OTKcm2W16PmWc4FWWXNSlWM2n3D+uPxuyrcfo74aP+Ac30a82+oLmfAAAAAElFTkSuQmCC"


@connect(mapStateToProps, mapDispatchToProps)
export class CustomerProfile extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            open: false,
            codeProd: '',
            loaded: false,
            client: null,
            locked: false,
            clients: [],
            customerDetails: null,
            details: false,
            metricData: null,
            userId: null,
            msg: null,
            variant: 'success',
            showContactModal: false,
            showAccountModal: false,
            showPoItems: false,
            instagramImage: null,
            last_name_error_text: null,
            dni_error_text: null,
            temp_dni: null,
            temp_username: null,
            temp_insta: null,
            byInsta: true,
            columns: [{ name: "id", options: { display: false, filter: false, download: false, print: false } },
            { name: "Fecha", options: { filter: false, rowHover: false } },
            {
                name: "Monto",
                options: {
                    filter: false, rowHover: false,
                    customBodyRender: value => <NumberFormat
                        value={value}
                        displayType={'text'}
                        thousandSeparator={'.'}
                        decimalSeparator={','}
                        prefix="$"
                    />
                }
            },
            { name: "Estado", options: { filter: false, rowHover: false } },
            {
                name: "Items", options: {
                    filter: false,
                    download: false,
                    print: false,
                    sort: false,
                    customBodyRender: value => <SearchIcon />
                }
            },
            ],
            pos: [],
            poId: null,
            poItems: null,
            options: {
                filterType: 'checkbox',
                rowsPerPage: 5,
                selectableRows: false,
                downloadOptions: {
                    filename: 'Ordenes de compra Cliente.csv',
                    separator: ','
                },
                onCellClick: (cellIndex, rowIndex) => {
                    this.getPoDetail(cellIndex, rowIndex);
                },
                textLabels: {
                    body: {
                        noMatch: "No hay ordenes de compra",
                        toolTip: "Sort",
                    },
                    pagination: {
                        next: "Siguiente pag",
                        previous: "Anterior",
                        rowsPerPage: "Filas por pagina:",
                        displayRows: "de",
                    },
                    toolbar: {
                        search: "Buscar",
                        downloadCsv: "Descargar CSV",
                        print: "Imprimir",
                        viewColumns: "Ver columnas",
                        filterTable: "Filtrar tabla",
                    },

                },

            }
        }
        this.onSearch = this.onSearch.bind(this)
        this.handleClose = this.handleClose.bind(this)
        this.searchCustomer = this.searchCustomer.bind(this)
    }

    componentDidMount = () => {
        UserApi.getCustomerList(this.state.byInsta).then(response => {
            this.setState({ clients: response.data })

        }).catch(error => {
            console.log(error)
            this.setState({ clients: [] })
        })
    }
    getPoDetail = (_, rowIndex) => {
        if (rowIndex.colIndex != 4 || this.state.showPoItems) {
            return
        }
        const poId = this.state.pos[rowIndex.dataIndex][0]
        PurchaseApi.getPoDetails(poId)
            .then(response => {
                this.setState({ showPoItems: true, poId: poId, poItems: response.data })
            })
            .catch(error => {
                console.log(error)
            })

    }
    onSearch(e) {
        this.setState({ open: true });
    }
    handleClose(event, reason) {
        if (reason === 'clickaway') {
            return;
        }

        this.setState({ open: false });
    }
    changeCustomerList = (e) =>{
        UserApi.getCustomerList(!this.state.byInsta).then(response => {
            this.setState({ clients: response.data, byInsta: !this.state.byInsta })

        }).catch(error => {
            console.log(error)
            this.setState({ clients: [] })
        })
    }

    searchCustomer(userId) {
        UserApi.getCustomerDetails(userId).then(response => {
            this.setState({
                customerDetails: response.data.customer,
                userId: userId,
                temp_insta: response.data.customer.instagram,
                temp_dni: response.data.customer.dni,
                temp_username: response.data.customer.last_name,
                instagramImage: response.data.customer.instagram_profile_pic
            })
            this.getPurchaseOrders(userId)

        }).catch(error => {
            console.log(error)
            this.setState({ open: true, msg: 'El cliente no existe', variant: 'error' })
        })
    }

    getPurchaseOrders = (userId) => {
        PurchaseApi.getCustomerPurchases(userId)
            .then(response => {
                let rows = []
                response.data.map(function (obj) {
                    const formatedDate = new Date(obj.created_on + ' UTC')
                    // const date = formatedDate.getDate() + "-" + parseInt(formatedDate.getMonth() + 1) + "-" + formatedDate.getFullYear();
                    const date = formatedDate.getFullYear() + "-" + (formatedDate.getMonth() + 1) + "-" + formatedDate.getDate();

                    rows.push([obj.id, date, obj.total, obj.status, 2])
                })
                return rows


            }).then(rows => {
                this.setState({ pos: rows })
            })

    }
    showMetrics = (e) => {
        if (!this.state.details) {
            this.fetchMetrics()
            this.setState({ metricData: null })
        }
        this.setState({ details: !this.state.details })

    }
    fetchMetrics = () => {
        UserApi.getMetrics(this.state.userId)
            .then(response => {
                this.setState({ metricData: response.data })
            })
            .catch(error => {
                console.log(error);
            })
    }
    setCustomer = (newValue) => {
        this.setState({ client: newValue })

    }


    onCloseModal = () => {
        this.setState({ showPoItems: false })
    }

    editContact = () => {
        this.setState({ showContactModal: true })
    }

    editAccount = () => {
        this.setState({ showAccountModal: true })
    }

    handleClickAway = (asdas) =>{
        this.setState({ showContactModal: false })
    }

    setCustomerName = (value) =>{
        let custdata = this.state.customerDetails
        custdata.last_name = value;
        this.setState({customerDetails: custdata})

    }
    update = (e) => {
        e.preventDefault();
        UserApi.updateCustomer(this.state.userId,
            this.state.temp_dni,
            this.state.temp_insta.trim(),
            this.state.temp_username.trim()
        ).then(_ => {
            let custdata = this.state.customerDetails
            custdata.last_name = this.state.temp_username.trim();
            custdata.dni = this.state.temp_dni.trim();
            custdata.instagram = this.state.temp_insta.trim();
            this.setState({customerDetails: custdata,  showContactModal: false})
        })
            .catch(error => {
                console.log(error)
            })
    }

    render() {
        return (<div>

            <div className="col-md-12" style={{ marginTop: 20, marginLeft: -15 }}>

                <div className='col-md-3'>
                    <Suggestor
                        autoFocus
                        setValue={this.setCustomer}
                        suggestions={this.state.clients}
                        placeholder={this.state.byInsta?'Instagram':'DNI sin puntos'}
                        fetch={this.searchCustomer}
                    />
                </div>
                <div className='col-md-1' style={{ marginTop: 3, marginLeft: -60 }} >
                    <Switch
                      checked={this.state.byInsta}
                      onChange={this.changeCustomerList}
                      color="primary"
                    />
                </div>
                <Notification
                    open={this.state.open}
                    variant={this.state.variant}
                    message={this.state.msg}
                    onClose={this.handleClose}
                />


            </div>
            {this.state.customerDetails ?
            <div>
                <div className='col-md-12' style={{ marginTop: 20, marginLeft: -30}}>
                    <div className='col-md-6' >
                        <div className='col-md-8' style={{ marginTop: 20 }}>
                            <Typography variant="h6" gutterBottom>
                                Contacto
                            </Typography>
                        </div>
                        <div className='col-md-2' style={{ marginTop: 10 }}>
                            <IconButton onClick={this.editContact} aria-label="Search">
                                <CreateIcon />
                            </IconButton>

                        </div>
                        <div className='col-md-12'>
                            <Divider />

                            <Typography variant="subtitle2" gutterBottom style={{ marginTop: 10 }}>
                                <b>Apellido:  </b>{this.state.customerDetails.last_name}
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom style={{ marginTop: 10 }}>
                                <b>DNI:  </b>{this.state.customerDetails.dni}
                            </Typography>
                            <Typography variant="subtitle2" gutterBottom style={{ marginTop: 10 }}>
                                <b>Primer compra :  </b><Moment local format="DD-MM-YYYY">{this.state.customerDetails.created_on}</Moment>
                            </Typography>

                        </div>
                    </div>
                    <div className='col-md-3 col-md-offset-3' >
                        <div className='col-md-10' style={{ marginTop: 50 }}>
                        {this.state.instagramImage &&

                          <img
                            src={this.state.instagramImage !==null ?this.state.instagramImage:NO_IMAGE}
                            style={{width:150, height: 150, borderRadius: 150/ 2}}
                           />
                        }
                        {this.state.customerDetails?< Typography variant="subtitle1" gutterBottom style={{ marginTop: 10, marginLeft: 40}}>
                                <b>{this.state.customerDetails.instagram}</b>
                            </Typography>:<div></div>}
                        </div>
                    </div>
                </div>

                <div className='col-md-12' style={{ marginTop: 20 }}>
                    <Typography variant="h6" gutterBottom>
                        Ordenes de compra
                    </Typography>
                    <Divider />
                    <MUIDataTable
                        data={this.state.pos}
                        columns={this.state.columns}
                        options={this.state.options}
                    />
                </div>
                </div>: <div></div>}
            {(this.props.userRoles.includes(ADMIN_ROLE) && this.state.client) ?
                <div className='col-md-12' style={{ marginTop: 20 }}>
                    <div className='col-md-6'>
                        <FormGroup row>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={this.state.details}
                                        onChange={this.showMetrics}
                                        color="primary"

                                    />
                                }
                                label='Detalles'
                            />
                        </FormGroup>
                    </div>

                </div>
                : <div></div>}

            <Modal
                style={customStyles}
                open={this.state.showPoItems}
                onClose={this.onCloseModal}
                onBlur

            >
                <Paper elevation={4}>
                    <div style={{ marginTop: 30 }}>
                        <div style={{ marginLeft: 20, marginTop: 30 }}>
                            <Typography variant="h6" gutterBottom>
                                Orden de compra: {this.state.poId}
                            </Typography>
                        </div>
                        <Divider />
                        <div >
                            <PoItems data={this.state.poItems} />

                        </div>
                    </div>
                </Paper>
            </Modal>

            <Modal
                style={styleContact}
                aria-labelledby="Cambio cuenta"
                open={this.state.showContactModal}
                onClose={this.onClose}
            >
                <ClickAwayListener onClickAway={this.handleClickAway}>
                    <Paper elevation={4}>
                        <div className="text-center">
                            <br></br>
                            <div style={{ marginTop: 10 }}>
                                <Typography variant="h6" gutterBottom>
                                    Datos de contacto
                            </Typography>
                                <Divider />
                                <TextField
                                    error={Boolean(this.state.instagram_error_text)}
                                    placeholder="Instagram"
                                    type="text"
                                    value={this.state.temp_insta}
                                    helperText={this.state.instagram_error_text}
                                    onChange={(e) => this.setState({temp_insta: e.target.value})}
                                />
                                <br></br>
                                <TextField
                                    error={Boolean(this.state.DNI_error_text)}
                                    placeholder="DNI"
                                    type="text"
                                    value={this.state.temp_dni}
                                    helperText={this.state.DNI_error_text}
                                    onChange={e => {
                                        let value = e.target.value;

                                        value = value.replace(/[^0-9]/gi, "");

                                        this.setState({
                                            temp_dni: value
                                        });
                                    }}
                                />
                                <br></br>
                                <TextField
                                    error={Boolean(this.state.last_name_error_text)}
                                    placeholder="Apelido"
                                    type="text"
                                    value={this.state.temp_username}
                                    helperText={this.state.last_name_error_text}
                                    onChange={e => {
                                        let value = e.target.value;
                                        value.replace(/[^A-Za-z\s]/gi, "")
                                        this.setState({
                                            temp_username: value
                                        });
                                    }}

                                />
                                <br></br>
                                <Button
                                    variant="contained"
                                    color="primary"
                                    disabled={this.state.disabled}
                                    onClick={(e) => this.update(e)}
                                >
                                    Actualizar
                                </Button>
                                <br></br>
                                <br></br>
                            </div>

                        </div>

                    </Paper>
                </ClickAwayListener>
            </Modal >



            {this.state.details && this.state.metricData != null ?
                // <div style={{ height: 700, marginTop: 320 }}>
                <div>
                    <CustomerMetrics
                        style={{ marginTop: 300 }}
                        metrics={this.state.metricData}

                    />
                </div> : <div></div>


            }
        </div>
        )
    }
}



// WEBPACK FOOTER //
// ./src/components/Customer/CustomerProfile.js